export default __webpack_public_path__ + "static/kazuki-f3f04b6787eb10fe06d7588ce48eaba6.jpeg";